import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=54fe5fda&scoped=true"
import script from "./DropDown.vue?vue&type=script&lang=js"
export * from "./DropDown.vue?vue&type=script&lang=js"
import style0 from "./DropDown.vue?vue&type=style&index=0&id=54fe5fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe5fda",
  null
  
)

export default component.exports